import {images} from "../../../components/images";

export const devEnterpriseUploadImageGetUrl = {
    "image": images.devDataStoreProduct
};